import {
  optionalLiteralParam,
  optionalStringParam,
  parseableSearchSchema,
} from "@crm/effect/schema/search";
import { Schema } from "effect";

export const classSessionSearchSchema = parseableSearchSchema(
  Schema.Struct({
    courseId: optionalStringParam(),
    status: optionalLiteralParam("upcoming", "ongoing", "finished"),
  }),
);

export type ClassSessionSearch = Schema.Schema.Type<typeof classSessionSearchSchema>;
